export default __webpack_public_path__ + "static/media/login-image.66180957.png";